document.addEventListener("DOMContentLoaded", function() {

    // Setting men variable to false
    var configMenu = {
        active: false,
        classHamburgerClose: 'hamburger_close',
        classSlide: 'header_slide',
        classVisible: 'header_visible',
        hamburger: document.getElementsByClassName('hamburger')[0],
        header: document.getElementsByClassName('header')[0]
    };

    // Open Menu function
    function menuOpen(button) {
        configMenu.active = true;
        configMenu.header.classList.toggle(configMenu.classSlide);

        setTimeout(function() {
            button.classList.toggle(configMenu.classHamburgerClose);
            configMenu.header.classList.toggle(configMenu.classVisible);
        }, 300);
    }

    // Close Menu function
    function menuClose(button) {
        button.classList.toggle(configMenu.classHamburgerClose);
        configMenu.header.classList.toggle(configMenu.classVisible);

        setTimeout(function(){
            configMenu.header.classList.toggle(configMenu.classSlide);
            configMenu.active = false;
        }, 300);
    }

    // Run On Click function
    configMenu.hamburger.addEventListener('click', function() {
        if(configMenu.active) {
            menuClose(this);
        } else {
            menuOpen(this);
        }
	});
});